<template>
    <div>

        <mavon-editor1></mavon-editor1>

    </div>


</template>

<script>
    import mavonEditor1 from '../../components/mavonEditor1'
  export default {
    name: "write-blog",
    components:{
      mavonEditor1,

    }
  }
</script>

<style scoped>

</style>